var sortEarnings = function (_a) {
    var rewardsBalance = _a.rewardsBalance, earningsIcons = _a.earningsIcons;
    var earningsIds = Object.keys(earningsIcons || {});
    return rewardsBalance === null || rewardsBalance === void 0 ? void 0 : rewardsBalance.rewardDetails.filter(function (details) { return earningsIds.includes(details.Id); }).sort(function (a, b) { return earningsIds.indexOf(a.Id) - earningsIds.indexOf(b.Id); });
};
export default sortEarnings;
